<div class="p-3 mb-3 border border-dark">
  <dl>
    <div class="row align-items-center mb-3">
      <dt class="col-6 mx-auto">Subtotal</dt>
      <dd class="col-6 h5 mx-auto">{{subtotal | currency}}</dd>
    </div>
    <div class="row align-items-center mb-3">
      <dt class="col-6">Tax</dt>
      <dd class="col-6 tax h6">{{tax | currency}}</dd>
    </div>
    <hr class="col-11 bg-medium" role="layout">
    <div class="row align-items-center mt-4">
      <dt class="col-6">Total</dt>
      <dd class="col-6 total h3">{{total | currency}}</dd>
    </div>
  </dl>
</div>